<template>
    <validation-observer ref="customField">
         <div class="customField">
            <div class="title"> {{$t('customer.wizzard.customFields')}} </div>
            <b-form class="formBox">
                 <validation-provider v-for="item in data"  :key="item.id" :name="item.field_label" :rules="{ required: item.is_required}" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="item.field_label" :label-for="String(item.id)">
                        <b-form-input
                            :id="String(item.id)"
                            v-model="item.field_value.value"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                            v-if="item.type == 'text'"
                        ></b-form-input>
                        <Datetime v-else-if="item.type == 'date'" v-model="item.field_value.Value"></Datetime>
                        <Multiselect  
                            v-model="item.field_value.value"
                            :show-labels="false" 
                            :options="[]"
                            label="name"
                            track-by="id"
                            v-else-if="item.type == 'dropdown'" >
                                <template slot="singleLabel" slot-scope="{ option }">
                                    <strong>{{ option.name }} </strong> 
                                </template>
                        </Multiselect>
                          <b-form-textarea 
                            :id="item.id"
                            rows="3"
                            v-model="item.field_value.value"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                            v-else-if="item.type == 'textarea'"
                        ></b-form-textarea>
                        <b-form-radio-group
                            v-else-if="item.type == 'checkbox'"
                            :id="item.id"
                           v-model="item.field_value.value"
                            :options="yesNo"
                            aria-describedby="live-feedback"></b-form-radio-group>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>
              </validation-provider>
            </b-form>
          
        </div>
    </validation-observer>
</template>

<script>
import { Datetime } from 'vue-datetime';
import Multiselect from 'vue-multiselect'

export default {
    name: 'CustomField',
    data: function(){
        return {
            yesNo: [
                {text: 'Evet', value: true},
                {text: 'Hayır', value: false}
            ]
        }
    },
    props:{
        //type: String,
        data: Array
    },
    components:{
        Datetime, Multiselect
    },
    methods:{
        getValidationState({ dirty, validated, valid = null }) {
            return dirty || validated ? valid : null;
        },
    }
}
</script>

<style scoped>
    @import "./styles/customField.min.css";

</style>


// WEBPACK FOOTER //
// src/components/CustomField.vue